var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "balances_container"
  }, [_c('div', {
    staticClass: "bar"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(" " + _vm._s(_vm._f("pluralize")(Object.keys(_vm.assets).length, 'asset')) + " found ")])]), _vm.assets.length > 0 ? _c('div', {
    staticClass: "grid_headers balance_row"
  }, [_c('p', [_vm._v(" Symbol "), _c('Tooltip', {
    attrs: {
      "content": "An arrangement of letters representing an asset"
    }
  })], 1), _c('p', {
    staticClass: "name"
  }, [_vm._v(" Name "), _c('Tooltip', {
    attrs: {
      "content": "Name for the asset"
    }
  })], 1), _c('p', {
    staticClass: "balance"
  }, [_c('Tooltip', {
    attrs: {
      "content": "Balance held by this address"
    }
  }), _vm._v(" Balance ")], 1), _c('p', {
    staticClass: "sent"
  }, [_c('Tooltip', {
    attrs: {
      "content": "Total sent by this address"
    }
  }), _vm._v("Sent ")], 1), _c('p', {
    staticClass: "received"
  }, [_c('Tooltip', {
    attrs: {
      "content": "Total received by this address"
    }
  }), _vm._v(" Received ")], 1), _c('p', {
    staticClass: "utxos"
  }, [_c('Tooltip', {
    attrs: {
      "content": "Total UTXOs that are currently spendable by this address (includes locked and unlocked UTXOs)"
    }
  }), _vm._v(" Spendable UTXOs ")], 1)]) : _vm._e(), _vm._l(_vm.assets, function (asset, index) {
    return _c('BalanceRow', {
      key: index,
      attrs: {
        "asset": asset
      }
    });
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }